import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './others/guards/auth.guard';

import { LoginComponent } from './components/login/login.component';
import { NotFoundComponent } from './components/others/not-found/not-found.component';
import { MainComponent } from './components/main/main.component';
import { DashboardComponent } from './components/main/content/dashboard/dashboard.component';
import { ThirdPartiesComponent } from './components/main/content/third-parties/third-parties.component';
import { SettingsComponent } from './components/main/content/settings/settings.component';
import { FeatureUpdatesComponent } from './components/main/content/feature-updates/feature-updates.component';
import { DownloadsConfigComponent } from './components/main/content/downloads-config/downloads-config.component';
import { UsageReportsComponent } from './components/main/content/usage-reports/usage-reports.component';
import { ForceUpdateComponent } from './components/main/content/force-update/force-update.component';
import { WhitelabelsComponent } from './components/main/content/whitelabels/whitelabels.component';

const routes: Routes = [
  { path: '', component: MainComponent, canActivate: [AuthGuard],
    children: [
      { path: '', component: DashboardComponent },
      { path: 'thirdparties', component: ThirdPartiesComponent },
      { path: 'settings', component: SettingsComponent },
      { path: 'feature-updates', component: FeatureUpdatesComponent },
      { path: 'downloads-config', component: DownloadsConfigComponent },
      { path: 'force-update', component: ForceUpdateComponent },
      { path: 'usage-reports', component: UsageReportsComponent },
      { path: 'whitelabels', component: WhitelabelsComponent }
    ]
  },
  { path: 'login', component: LoginComponent },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
